import { Button, DatePicker, Input, message, Select } from 'antd'
import React, { Fragment, useState } from 'react'
import './search.less'
import bgImg from '@/assets/search-bg.png'
import logoImg from '@/assets/logo-red.png'

export default function Search() {
  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [dob, setDob] = useState(null)
  const [phone, setPhone] = useState('')
  const [type, setType] = useState(1)

  function search() {
    if (type === 1) {
      if (!name || !phone) {
        message.error('请输入姓名和手机号')
        return
      }
    } else if (type === 2) {
      if (!code) {
        message.error('请输入证书编号')
        return
      }
    }

    const dobStr = dob?.format('YYYY-MM-DD') ?? ''
    window.location.href = `#/common/train/detail?name=${name}&birth=${dobStr}&phone=${phone}&code=${code}&type=${type}`
  }

  return (
    <div className="mls">
      <img className="bg" src={bgImg} />
      <div className="panel">
        <img className="logo" src={logoImg} />
        <div className="title">个人培训证书查询</div>
        <div className="type">
          <span>类型：</span>
          <Select value={type} onChange={setType} size="large">
            <Select.Option value={1}>2022年8月份以后的证书查询</Select.Option>
            <Select.Option value={2}>2022年8月份以前的证书查询</Select.Option>
          </Select>
        </div>
        {type === 1 && (
          <>
            <div className="ipt-container">
              <Input
                placeholder="请输入姓名"
                value={name}
                onChange={(evt) => setName(evt.target.value)}
              />
              <span className="required">*</span>
            </div>
            <div className="ipt-container">
              <DatePicker
                placeholder="请输入出生年月"
                value={dob}
                onChange={(val) => setDob(val)}
              />
            </div>
            <div className="ipt-container">
              <Input
                placeholder="请输入手机号"
                value={phone}
                onChange={(evt) => setPhone(evt.target.value)}
              />
              <span className="required">*</span>
            </div>
          </>
        )}
        {type === 2 && (
          <>
            <div className="ipt-container">
              <Input
                placeholder="请输入证书编号"
                value={code}
                onChange={(evt) => setCode(evt.target.value)}
              />
              <span className="required">*</span>
            </div>
          </>
        )}
        <Button onClick={search}>
          查询&nbsp;<span className="iconfont">&#xe678;</span>
        </Button>
      </div>
    </div>
  )
}
